

import { TileModel } from "src/class/tileModel";
import { IconArrowDown, IconBookmark, IconBookmarkClear, IconEyeHide, IconEyeShow, IconMoveModel, IconSave, IconSearch } from "../icon";
import { getMessage } from '../language';
import "../styles/treeTileModel.css";
import { DialogGeneral } from "../utils/Dialog/dialog";
import { createUUID, findBoundingBoxFromTileModel } from "../utils/utils";

import { FormMoveModel } from "./Dialog/formMoveModel";
import { DialogService, ETypeDialogService } from "./Dialog/serviceDialog";
import { SceneManager } from "./sceneManager";



export class TreeTileModel {
    viewer: any;
    containerId: string;
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạo
    modal: any
    treeViews: TileModel[] = [];//Mảng phẳng
    _childrenTreeMap = new Map<string, TileModel[]>(); // lưu con theo parentID
    _itemTreeMap = new Map<string, TileModel>();       // lưu item theo id
    dialog: DialogGeneral | undefined;
    callBackSaveHiddenTreeViews?: (data: any) => void | undefined
    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;
    constructor(containerId: string, viewer: any, treeViews: TileModel[], _sceneManager: SceneManager) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.treeViews = treeViews

        this.createModalTreeFolder()
        this.dialog?.showModal(false)
    }


    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
        } else {
            console.error("State change callback is not set.");
        }
    }

    // setSaveHiddenTreeViews = (callback: (data: any) => void) => {

    // }
    triggerChange = (data: any) => {
        if (this.callBackSaveHiddenTreeViews) {
            this.callBackSaveHiddenTreeViews(data);
        }
    }

    /**
   * Hàm khởi tạo popup modal
   */

    createModalTreeFolder = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage('model-title-dialog');
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;
        this.dialog.widthModal = '300px'
        this.dialog.heightModal = '500px'
        this.dialog.zIndex = 101
        this.dialog.topModal = '5px'
        this.dialog.leftModal = '5px'
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this.dialog.innerBody = this.renderTreeView();
        this.dialog.innerFooter = this.renderFooter();
        this.dialog.createDialog();
        this.initKeyboardEvents()


    }
    private _isCalFooter = false;


    //#region showModalTreeFolder
    showHideModalTreeFolder = (show: boolean) => {
        if (this.callBackSaveHiddenTreeViews && show && !this._isCalFooter) {
            setTimeout(() => {
                this.dialog?.calFooterHeight()
                this._isCalFooter = true
            }, 50)

        }
        this.dialog?.showModal(show)

    }


    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)
        }
    }
    private containerUl: HTMLUListElement | undefined

    private _idTreeView = `list-tree-${this.IdGenneral}`
    // Hàm renderTreeView đã sửa
    renderTreeView = (): HTMLElement => {
        // Nếu containerUl đã tồn tại, remove nó khỏi DOM
        if (this.containerUl) {
            this.clearContainer()
        } else {
            // Tạo lại containerUl mới
            this.containerUl = document.createElement('ul');
            this.containerUl.id = this._idTreeView;
            this.containerUl.className = "container-treelist";

            this.containerUl.addEventListener('contextmenu', (event) => this._reverseTreeShow(event));

        }
        // Các mục có parentID == null hoặc không có parentID
        const rootItems = this.treeViews.filter((item: any) => !item.parentID);
        // Thêm các phần tử con mới vào containerUl
        rootItems.forEach((item: any) => {
            const fragment = this.createTreeItem(this.treeViews, item);
            this.containerUl!.appendChild(fragment);
        });

        //Map hóa các item và children để dễ dàng tìm kiếm theo ID
        this._itemTreeMap = new Map<string, any>();
        this._childrenTreeMap = new Map<string, any[]>();

        this.treeViews.forEach((item: any) => {
            this._itemTreeMap.set(item.id, item);

            if (item.parentID) {
                if (!this._childrenTreeMap.has(item.parentID)) {
                    this._childrenTreeMap.set(item.parentID, []);
                }
                this._childrenTreeMap.get(item.parentID)!.push(item);
            }
        });

        return this.containerUl;
    };
    //#region renderFooter
    private containerFooter: HTMLElement | undefined
    renderFooter = (): HTMLElement => {
        if (!this.containerFooter) {
            this.containerFooter = document.createElement('div');
            this.containerFooter.id = `footer-tree-folder-${this.containerId}`;

        } else {
            this.containerFooter.style.marginTop = '5px';
            //Btn move model
            const moveModelBtn = document.createElement('button');
            moveModelBtn.id = `btn-move-model-${this.IdGenneral}`;
            moveModelBtn.className = 'DPU-btn-defaut-style';
            moveModelBtn.style.marginRight = '5px';
            moveModelBtn.innerHTML = IconMoveModel()
            this.containerFooter.appendChild(moveModelBtn)
            if (moveModelBtn) {
                moveModelBtn.addEventListener('click', () => {
                    this.handleOpenFormMoveModel()
                })
            }
            //Btn save model
            const saveButton = document.createElement('button');
            saveButton.id = `btn-tree-download-${this.containerId}`;
            saveButton.className = 'DPU-btn-defaut-style';
            saveButton.style.marginRight = '5px';

            saveButton.innerHTML = IconSave();
            saveButton.addEventListener('click', () => {
                const newList = this.getTreeView();
                this.triggerChange({
                    action: 'getHiddenTreeViews',
                    data: newList
                })
            });
            this.containerFooter.appendChild(saveButton)
            //Btn bookmark model
            const bookmarkBtn = document.createElement('button');
            bookmarkBtn.id = `btn-bookmark-${this.IdGenneral}`;
            bookmarkBtn.className = 'DPU-btn-defaut-style';
            bookmarkBtn.style.marginRight = '5px';

            bookmarkBtn.innerHTML = IconBookmark();
            this.containerFooter.appendChild(bookmarkBtn)

            bookmarkBtn.addEventListener('click', () => {
                this._setDefaultModel()
            })

            //Btn clear bookmark model
            const clearBookmarkBtn = document.createElement('button');
            clearBookmarkBtn.id = `btn-bookmark-clear-${this.IdGenneral}`;
            clearBookmarkBtn.className = 'DPU-btn-defaut-style';
            clearBookmarkBtn.style.marginRight = '5px';

            clearBookmarkBtn.innerHTML = IconBookmarkClear();
            clearBookmarkBtn.addEventListener('click', () => {
                this.clearAllLoadDefaultDot()
            })
            this.containerFooter.appendChild(clearBookmarkBtn)


        }
        return this.containerFooter;
    }

    //#region handelOpenFormMoveModel
    handleOpenFormMoveModel = () => {
        // console.log('this.selectedRow', this.selectedRow);
        // console.log('this.selectedItems', this.selectedItems);
        if (this.selectedRow && this.selectedItems.size == 1) {
            new FormMoveModel(this.containerId, this.viewer, this.treeViews, [this.selectedRow])
        } else if (this.selectedItems.size > 1) {
            const selectedRows = Array.from(this.selectedItems).map(id => this.treeViews.find(item => item.id === id)) as TileModel[];
            new FormMoveModel(this.containerId, this.viewer, this.treeViews, selectedRows)
        }
    }

    //#region clearContainer
    private clearContainer = () => {
        if (this.containerUl) {
            // while (this.containerUl.firstChild) {
            //     this.containerUl.removeChild(this.containerUl.firstChild);
            // }
            this.containerUl.innerHTML = '';
        }
    };

    //#region Create Tree
    private selectedItems: Set<string> = new Set(); // Lưu trữ các ID đã được chọn
    private lastSelectedItem: HTMLLIElement | null = null; // Lưu trữ mục cuối cùng được chọn (cho Shift chọn)
    private selectedRow?: TileModel

    private createTreeItem = (flatData: any[], currentItem: any): DocumentFragment => {
        const fragment = document.createDocumentFragment();

        // Tạo li chính cho item hiện tại
        const li = document.createElement('li');
        li.className = "dpu-tree-item";
        li.setAttribute('data-id', currentItem.id);

        // Tạo div chứa nền được chọn
        const fullrow = document.createElement('div');
        fullrow.className = "fullrow";

        // Thêm sự kiện chọn mục
        li.addEventListener('click', (event) => this.handleItemSelection(event, li, currentItem));
        // li.addEventListener('dblclick', (event) => this.handleItemDBSelection(event, li, currentItem));

        // Tạo span chứa tên thư mục
        const span = this.createCaretSpan(currentItem);
        span.addEventListener('dblclick', (event) => this.handleItemDBSelection(event, li, currentItem));

        // Tìm các mục con
        const children = flatData.filter(item => item.parentID === currentItem.id);

        if (children.length > 0) {
            // Nếu có mục con, tạo arrow và nested container
            const { arrow, nestedUl } = this.createNestedContainer(currentItem, children, flatData);
            span.prepend(arrow); // Thêm arrow vào đầu span
            fragment.appendChild(li);
            fragment.appendChild(nestedUl);
        } else {
            // Nếu không có mục con, thêm placeholder
            const placeholder = document.createElement('span');
            placeholder.className = "arrow-placeholder";

            span.prepend(placeholder);
            fragment.appendChild(li);
        }
        // Thêm span và nút vào li
        const buttonContainer = this.createButtonContainer(currentItem, li);
        li.appendChild(fullrow);
        li.appendChild(span);
        li.appendChild(buttonContainer);

        return fragment;

    };

    //#region handleItemSelection
    /**
         * Xử lý sự kiện chọn mục
         */
    private handleItemSelection(event: MouseEvent, li: HTMLLIElement, currentItem: any): void {
        const isCtrl = event.ctrlKey;
        const isShift = event.shiftKey;

        if (isCtrl) {
            this.toggleSelectItem(li, currentItem);
            return;
        }

        if (isShift && this.lastSelectedItem) {
            this.selectRange(li, currentItem);
            return;
        }

        this.selectSingleItem(li, currentItem);
    }

    private _reverseTree: TileModel[] = []
    //#region handleItemDBSelection

    handleItemDBSelection(event: MouseEvent, li: HTMLElement, currentItem: any): void {
        if (this._reverseTree.length == 0) {
            this._reverseTree = this.treeViews.filter((tile: TileModel) => tile.isShow == false)
        }
        const showButton = li.querySelector('.folder-button') as HTMLElement
        this.treeViews.forEach((tileModel: TileModel) => {
            tileModel.isShow = false

            //rerender lại 
            const divBtn = this.containerUl!.querySelector(`div[data-folder-id="${tileModel.id}"]`);
            if (divBtn) {
                divBtn.innerHTML = IconEyeHide()
            }
        })

        if (showButton) {
            this._handleToggleVisible(currentItem, showButton)
        }

        if (currentItem.contentType == '3dtile' || !currentItem.contentType) {
            setTimeout(() => {
                this._handleZoomTo(currentItem)

                this.viewer.scene.requestRender()
            }, 50)
        }
        if (currentItem.contentType == 'kmz') {
            setTimeout(() => {
                this._handleZoomTo(currentItem)

                this.viewer.scene.requestRender()
            }, 100)
        }


    }
    /**
       * Chọn hoặc bỏ chọn mục (Ctrl)
       */
    private toggleSelectItem(li: HTMLLIElement, currentItem: TileModel): void {
        const isSelected = li.classList.toggle('active');

        if (isSelected) {
            this.selectedItems.add(currentItem.id);
        } else {
            this.selectedItems.delete(currentItem.id);
        }
        if (this.selectedItems.size === 1) {

            this.selectedRow = currentItem
        }
        this.lastSelectedItem = li;
    }
    /**
        * Chọn một dải mục (Shift)
        */
    //#region selectRange
    private selectRange(li: HTMLLIElement, currentItem: any): void {

        const allTreeItems = Array.from(this.containerUl!.querySelectorAll('.dpu-tree-item'));
        const currentIndex = allTreeItems.indexOf(li);
        const lastIndex = allTreeItems.indexOf(this.lastSelectedItem!);

        const [start, end] = [currentIndex, lastIndex].sort((a, b) => a - b);
        for (let i = start; i <= end; i++) {
            const item = allTreeItems[i] as HTMLLIElement;
            if (!item.classList.contains('active')) {
                item.classList.add('active');
                this.selectedItems.add(item.getAttribute('data-id')!);
            }
        }
    }

    //#region selectSingleItem
    /**
     * Chọn một mục duy nhất
     */
    private selectSingleItem(li: HTMLLIElement, currentItem: any): void {

        //Lưu lại dòng được chọn
        this.selectedRow = currentItem

        const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
        allTreeItems.forEach(item => item.classList.remove('active'));

        li.classList.add('active');
        this.selectedItems.clear();
        this.selectedItems.add(currentItem.id);
        this.lastSelectedItem = li;
    }

    private initKeyboardEvents(): void {
        document.addEventListener('keydown', (event) => this.handleSelectAll(event));

    }

    //#region handleSelectAll
    /**
     * Xử lý Ctrl+A để chọn tất cả
     */
    private handleSelectAll(event: KeyboardEvent): void {
        if (event.ctrlKey && event.key === 'a') {
            event.preventDefault();

            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.add('active'));
            this.selectedItems.clear();
            allTreeItems.forEach(item => {
                this.selectedItems.add(item.getAttribute('data-id')!);
            });
        }
    }

    /**
     * Tạo span chứa caret và màu
     */
    private createCaretSpan(currentItem: any): HTMLSpanElement {
        const span = document.createElement('span');
        if (currentItem.isLoadDefault) {
            span.className = "caret padding-caret";
        } else {
            span.className = "caret";
        }

        const textNode = document.createElement('span');
        textNode.className = "text";
        textNode.textContent = currentItem.name;
        span.appendChild(textNode);

        return span;
    }

    /**
     * Tạo container cho mục con
     */
    private createNestedContainer(currentItem: any, children: any[], flatData: any[]): { arrow: HTMLSpanElement, nestedUl: HTMLUListElement } {
        const arrow = document.createElement('span');
        arrow.className = "arrow-icon";
        arrow.innerHTML = IconArrowDown();

        const nestedUl = document.createElement('ul');
        nestedUl.className = "nested";

        if (currentItem.expand) {
            nestedUl.classList.add("active");
            arrow.classList.add("arrow-down");
        }

        children.forEach(childItem => {
            nestedUl.appendChild(this.createTreeItem(flatData, childItem));
        });

        arrow.addEventListener("click", (event) => {
            // event.stopPropagation();
            currentItem.expand = !currentItem.expand
            nestedUl.classList.toggle("active");
            arrow.classList.toggle("arrow-down");
        });

        return { arrow, nestedUl };
    }

    //#region createButtonContainer
    /**
     * Tạo container cho các nút chức năng (ví dụ: tìm kiếm, xóa, chỉnh sửa)
     */
    private createButtonContainer(currentItem: any, li: HTMLLIElement): HTMLDivElement {
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'button-container';


        //Tại nút loadDefault
        if (currentItem.isLoadDefault) {
            const loadDefaultButton = document.createElement('div');
            loadDefaultButton.className = 'dpu-load-default-dot';
            buttonContainer.appendChild(loadDefaultButton);
        }

        // Tạo nút tìm kiếm
        const showButton = document.createElement('div');
        showButton.className = 'folder-button';
        showButton.setAttribute('data-folder-id', currentItem.id.toString());

        showButton.innerHTML = currentItem.isShow ? IconEyeShow() : IconEyeHide();
        //Hàm xử lý ẩn hiện model
        showButton.addEventListener('click', (event) => {

            // event.stopPropagation();
            this.lastSelectedItem = li
            if (this.selectedItems.has(currentItem.id) && this.selectedItems.size > 1) {
                let allChildItems: TileModel[] = [];
                const existingIds = new Set();


                // Lọc ra các phần tử trong treeViews có id trùng với selectedItems
                const matchingItems = this.treeViews.filter((tile: TileModel) =>
                    this.selectedItems.has(tile.id)
                );


                if (matchingItems) {

                    matchingItems.forEach((tile: TileModel) => {
                        // Add chính cái folder vào trước
                        if (!existingIds.has(tile.id)) {
                            existingIds.add(tile.id);
                            allChildItems.push(tile);
                        }

                        // Rồi lấy hết descendants như cũ
                        if (tile.isFolder) {
                            const descendants = this.getItemsTreeByParentId(this.treeViews, tile.id);
                            descendants.forEach((item: TileModel) => {
                                if (!existingIds.has(item.id)) {
                                    existingIds.add(item.id);
                                    allChildItems.push(item);
                                }
                            });
                        }
                    });

                    // let tempShow = !currentItem.isShow
                    allChildItems.forEach((tile: TileModel) => {
                        if (tile.id !== currentItem.id) {

                            const button = this.containerUl?.querySelector<HTMLElement>(`#${this._idTreeView} li div[data-folder-id="${tile.id}"]`);
                            if (button) {
                                if (tile.isShow == currentItem.isShow) {
                                    tile.isShow = !currentItem.isShow
                                    button!.innerHTML = tile.isShow ? IconEyeShow() : IconEyeHide();
                                }
                            }

                        }

                    })

                    currentItem.isShow = !currentItem.isShow
                    const btnCurrent = this.containerUl?.querySelector<HTMLElement>(`#${this._idTreeView} li div[data-folder-id="${currentItem.id}"]`);

                    if (btnCurrent) {
                        btnCurrent.innerHTML = currentItem.isShow ? IconEyeShow() : IconEyeHide();
                    }

                    //Chọn lại 1 row
                    this.selectSingleItem(li, currentItem)
                    this.viewer.scene.requestRender()
                }

            } else {
                //Trường hợp chỉ có 1 item được chọn
                this._handleToggleVisible(currentItem, showButton)

            }
            // this.handleItemSelection(event, li, currentItem)
            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = searchButton.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');
        });

        // Thêm nút vào container
        buttonContainer.appendChild(showButton);
        // Tạo nút tìm kiếm
        const searchButton = document.createElement('div');
        searchButton.className = 'search-button';
        searchButton.innerHTML = IconSearch(); // Hàm tạo biểu tượng tìm kiếm
        searchButton.addEventListener('click', (event) => {

            // event.stopPropagation();
            this.selectedRow = currentItem
            this._handleZoomTo(currentItem)
            // this.zoomLabelPoint(currentItem);

            // Làm nổi bật mục được chọn
            const allTreeItems = this.containerUl!.querySelectorAll('.dpu-tree-item');
            allTreeItems.forEach(item => item.classList.remove('active'));
            const parentLi = searchButton.closest('.dpu-tree-item') as HTMLLIElement;
            parentLi?.classList.add('active');
        });
        buttonContainer.appendChild(searchButton);




        return buttonContainer;
    }

    private _handleZoomTo = (dataView: TileModel) => {
        // console.log('_handleZoomTo',dataView);
        if (dataView.tileset) {
            dataView.zoomTo()
            // this.viewer.scene.requestRender()
        } else {

            const children = this.getItemsTreeByParentId(this.treeViews, dataView.id)
            dataView.parentZoomTo(children)
            // this.viewer.scene.requestRender()
        }
        this.viewer.scene.requestRender()

    }
    //#region _handleToggleVisible
    // Hàm xử lý khi nút bên trái được nhấn
    private _handleToggleVisible = (dataView: TileModel, button: HTMLElement) => {


        dataView.isShow = !dataView.isShow
        // Cập nhật lại nội dung nút dựa trên giá trị của isShow
        button.innerHTML = dataView.isShow ? IconEyeShow() : IconEyeHide();

        if (dataView.isShow) {
            this._setParentShow(this.treeViews, dataView.id)
        }
        this._updateChildButtons(dataView);
        this.viewer.scene.requestRender()
    }

    //#region _updateChildButtons
    private _updateChildButtons = (dataView: TileModel) => {

        // Tìm tất cả các phần tử con trong mảng phẳng (có parentId là id của dataView hiện tại)
        const childFolders = this.getItemsTreeByParentId(this.treeViews, dataView.id)
        // Lặp qua tất cả các thư mục con và cập nhật trạng thái
        childFolders.forEach(child => {
            // Cập nhật trạng thái của child dựa trên trạng thái của cha
            child.isShow = dataView.isShow;

            // Tìm button liên quan đến child này
            const button = document.querySelector<HTMLElement>(`#${this._idTreeView} li div[data-folder-id="${child.id}"]`);
            if (button) {
                button.innerHTML = child.isShow ? IconEyeShow() : IconEyeHide();
            }
        });
        //Kiểm tra tất cả thằng có cùng cấp cha xem có ẩn hết không
        if (!dataView.isShow) {
            this._updateVisibilityFromParentID(dataView)

        }

    }

    //#region _updateVisibilityFromParentID
    private _updateVisibilityFromParentID = (dataView: TileModel) => {
        const checkAndUpdate = (pid: string) => {
            if (!pid) return;
            const children = this._childrenTreeMap.get(pid);
            if (!children || children.length === 0) return;

            const allHidden = children.every(child => child.isShow === false);

            if (allHidden) {
                const parent = this._itemTreeMap.get(pid);
                if (parent && parent.isShow !== false) {
                    parent.isShow = false;
                    // Tìm button liên quan đến child này
                    const button = document.querySelector<HTMLElement>(`#${this._idTreeView} li div[data-folder-id="${parent.id}"]`);
                    if (button) {
                        button.innerHTML = parent.isShow ? IconEyeShow() : IconEyeHide();
                    }
                    if (parent.parentID) {
                        checkAndUpdate(parent.parentID);
                    }
                }
            }
        };

        checkAndUpdate(dataView.parentID!);

    }


    //#region _getItemsTreeByParentId
    //Tìm Item trong List theo parent
    getItemsTreeByParentId = (data: any, parentId: string) => {
        const result = [];
        const stack = [parentId]; // Sử dụng stack để duyệt qua tất cả các cấp

        while (stack.length > 0) {
            const currentParentId = stack.pop();
            // Lấy tất cả các phần tử có parentId khớp
            const children = data.filter((item: any) => item.parentID === currentParentId);

            // Thêm các phần tử vào kết quả
            result.push(...children);

            // Đưa id của từng phần tử vào stack để kiểm tra cấp con tiếp theo
            children.forEach((child: any) => stack.push(child.id));
        }

        return result;
    }
    //#region _setParentShow
    private _setParentShow(dataArray: TileModel[], targetId: string) {
        // Tạo Map để tra nhanh theo id
        const map = new Map();
        dataArray.forEach(item => {
            map.set(item.id, item);
        });

        let currentId = targetId;

        while (currentId) {
            const currentObj = map.get(currentId);
            if (!currentObj) break;
            if (currentObj.isFolder) {
                currentObj.isShow = true;
                const button = document.querySelector<HTMLElement>(`#${this._idTreeView} li div[data-folder-id="${currentObj.id}"]`);
                if (button) {
                    button.innerHTML = currentObj.isShow ? IconEyeShow() : IconEyeHide();
                }
            }
            currentId = currentObj.parentID;
        }
    }
    //#region _reverseTreeShow
    private _reverseTreeShow = (event: MouseEvent) => {
        event.preventDefault()
        const treeFolder = document.querySelector(`#list-tree-${this.IdGenneral}`)
        this.treeViews.forEach((tileModel: TileModel) => {
            tileModel.isShow = true

            const divBtn = treeFolder?.querySelector(`div[data-folder-id="${tileModel.id}"]`)
            if (divBtn) {
                divBtn.innerHTML = IconEyeShow();
            }
        })


        if (this._reverseTree.length == 0) return

        // Tạo Set chứa các ID cần set isShow = false
        const reverseTreeIds = new Set(this._reverseTree.map(tile => tile.id));
        // Cập nhật trực tiếp isShow trong treeViews
        this.treeViews.forEach(tile => {
            if (reverseTreeIds.has(tile.id)) {
                tile.isShow = false;
                // if (!(tile as any)._isShow) {
                //     (this.viewer as Viewer).scene.primitives.remove(tile.tileset)
                //     tile.tileset = undefined
                // } else {

                //     tile.getTileSet()

                // }
            }
        });

        reverseTreeIds.forEach((id) => {
            const divBtn = treeFolder?.querySelector(`div[data-folder-id="${id}"]`)
            if (divBtn) {
                divBtn.innerHTML = IconEyeHide();
            }
        })
        if (reverseTreeIds.size > 0) {
            this._reverseTree = []
        }
        // if (this._reverseTree.length > 0) {
        //     this.renderTreeView();
        //     this._reverseTree = []
        // }
    }


    //#region hasValidInputObjs

    // Hàm kiểm tra nếu bất kỳ giá trị nào trong inputObjs có giá trị hợp lệ (không phải undefined hoặc null)
    private hasValidInputObjs(inputObjs: any): boolean {
        if (!inputObjs) return false;  // Nếu inputObjs không tồn tại, trả về false

        const keys = ['x', 'y', 'z', 'height', 'latitude', 'longitude'];
        for (let key of keys) {
            if (inputObjs[key] !== undefined && inputObjs[key] !== null) {
                return true; // Nếu có bất kỳ key nào có giá trị hợp lệ, trả về true
            }
        }

        return false; // Nếu không có key nào có giá trị hợp lệ, trả về false
    }

    //#region _syncInputObjsFromParent
    // Hàm đồng bộ inputObjs từ cha sang con nếu con có giá trị undefined
    private _syncInputObjsFromParent(parentId: string) {
        // Truy cập trực tiếp vào item cha từ _itemTreeMap
        const parent = this._itemTreeMap.get(parentId);

        if (!parent) {
            return; // Nếu không có cha hoặc cha không có giá trị hợp lệ, thoát
        }

        // Truy cập vào các con của parent từ _childrenTreeMap
        const children = this._childrenTreeMap.get(parentId);

        if (children) {
            // Kiểm tra xem có bất kỳ child nào có giá trị hợp lệ trong inputObjs
            let hasValidChildInput = false;

            children.forEach(child => {
                if (this.hasValidInputObjs(child.inputObjs)) {
                    hasValidChildInput = true;
                }
            });

            // Nếu có bất kỳ child nào có giá trị hợp lệ, cập nhật parent.inputObjs
            if (hasValidChildInput) {
                // console.log("parent", parent);
                parent.inputObjs = {
                    x: undefined,
                    y: undefined,
                    z: undefined,
                    height: undefined,
                    latitude: undefined,
                    longitude: undefined,
                    maximumScreen: parent.inputObjs?.maximumScreen,
                    sizePointCloud: parent.inputObjs?.sizePointCloud,
                };

                // Đệ quy kiểm tra lên cha nếu có parentID
                if (parent.parentID) {
                    this._syncInputObjsFromParent(parent.parentID);
                }
            }
        }
    }

    //#region _setDefaultModel 
    private _setDefaultModel = () => {
        if (!this.selectedRow) return;

        if (!this.selectedRow.isShow) {
            this._showDialog()
        }

        // Xóa trạng thái load default cho tất cả node
        this.treeViews.forEach((item: TileModel) => {
            item.isLoadDefault = false;
            item.boundingBoxDefault = undefined;
            this._updateLoadDefaultDot(item.id, false);
        });

        // Đệ quy set trạng thái load default cho node và các con/cháu
        const setIsLoadDefaultRecursive = (nodeId: string) => {
            const node = this._itemTreeMap.get(nodeId);
            if (!node || !node.isShow) return;
            node.isLoadDefault = true;
            this._updateLoadDefaultDot(nodeId, true);
            const children = this._childrenTreeMap.get(nodeId);
            if (children && children.length > 0) {
                children.forEach(child => setIsLoadDefaultRecursive(child.id));
            }
        };
        setIsLoadDefaultRecursive(this.selectedRow.id);

        if (this.selectedRow.isFolder) {
            const children = this.getItemsTreeByParentId(this.treeViews, this.selectedRow.id)
            const boundingBoxDefault = findBoundingBoxFromTileModel(children)
            this.selectedRow.boundingBoxDefault = {
                min: {
                    x: boundingBoxDefault?.min.x ?? undefined,
                    y: boundingBoxDefault?.min.y ?? undefined,
                    z: boundingBoxDefault?.min.z ?? undefined

                },
                max: {
                    x: boundingBoxDefault?.max.x ?? undefined,
                    y: boundingBoxDefault?.max.y ?? undefined,
                    z: boundingBoxDefault?.max.z ?? undefined
                }
            }
        }

    };

    // Helper: cập nhật dấu chấm load default cho node
    private _updateLoadDefaultDot = (nodeId: string, isDefault: boolean) => {
        const dataId = this.containerUl?.querySelector(`li[data-id="${nodeId}"]`);
        if (!dataId) return;

        const spanCaret = dataId.querySelector('span.caret');
        if (spanCaret) {
            if (isDefault) {
                spanCaret.classList.add('padding-caret');
            } else {
                spanCaret.classList.remove('padding-caret');
            }
        }
        const buttonContainer = dataId.querySelector('.button-container');
        if (buttonContainer) {
            // Xóa hết các dot cũ
            const dots = buttonContainer.querySelectorAll('.dpu-load-default-dot');
            dots.forEach(dot => dot.remove());
            // Thêm dot mới nếu là default
            if (isDefault) {
                const dot = document.createElement('div');
                dot.className = 'dpu-load-default-dot';
                buttonContainer.insertBefore(dot, buttonContainer.firstChild);
            }
        }
    };

    //#region clearAllLoadDefaultDot
    // Xóa hết dấu chấm load default và cập nhật trạng thái
    public clearAllLoadDefaultDot(): void {
        this.treeViews.forEach((item: TileModel) => {
            item.isLoadDefault = false;
            item.boundingBoxDefault = undefined;
            const dataId = this.containerUl?.querySelector(`li[data-id="${item.id}"]`);
            if (dataId) {
                const spanCaret = dataId.querySelector('span.caret');
                if (spanCaret) {
                    spanCaret.classList.remove('padding-caret');
                }
                const buttonContainer = dataId.querySelector('.button-container');
                if (buttonContainer) {
                    const dots = buttonContainer.querySelectorAll('.dpu-load-default-dot');
                    dots.forEach(dot => dot.remove());
                }
            }
        });
    }

    //#region getTreeView
    getTreeView = () => {

        const newList: any = []

        this.treeViews.forEach((item: TileModel) => {
            if (item.parentID) {
                this._syncInputObjsFromParent(item.parentID); // Đồng bộ các giá trị inputObjs
            }

        })

        this.treeViews.forEach((item: TileModel) => {
            if (!item.isShow && item.isLoadDefault) {
                item.isLoadDefault = false
                item.boundingBoxDefault = undefined
            }


            newList.push({
                id: item.id,
                parrentID: item.parentID,
                name: item.name,
                isShow: item.isShow,
                isFolder: item.isFolder,
                x: item.inputObjs?.x,
                y: item.inputObjs?.y,
                z: item.inputObjs?.z,
                height: item.inputObjs?.height,
                latitude: item.inputObjs?.latitude,
                longitude: item.inputObjs?.longitude,
                maximumScreen: item.inputObjs?.maximumScreen,
                sizePointCloud: item.inputObjs?.sizePointCloud,
                isLoadDefault: item.isLoadDefault,
                boundingBoxDefault: item.boundingBoxDefault
            })
        })

        return newList

    }



    private _showDialog = async () => {
        const dialog = new DialogService({
            containerId: this.containerId,
            typeDialog: ETypeDialogService.Error,
            inputModal: {
                contentHeader: getMessage("dialog-service-question-header-load-default"),
                contentBody: getMessage("dialog-service-question-content-load-default")
            }
        });

        // Chờ đợi người dùng nhấn nút OK hoặc Cancel
        await dialog.showModalAndWait();

    }
}
